import { render } from "./StoryTellingBlock.vue?vue&type=template&id=4970e292"
import script from "./StoryTellingBlock.vue?vue&type=script&lang=js"
export * from "./StoryTellingBlock.vue?vue&type=script&lang=js"

import "./StoryTellingBlock.vue?vue&type=style&index=0&id=4970e292&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__